import { colors } from "theme";

export const appNavigation = {
  drawer: {
    background: "#ECEFF1",
    icon: {
      color: "#607D8B",
    },
  },
  stepper: {
    activeTab: {
      circleBackground: colors.purple[700],
      circleText: colors.white,
      labelColor: colors.purple[700],
    },
    inactiveTab: {
      labelColor: colors.gray[700],
      circleBackground: colors.gray[700],
      circleText: colors.white,
    },
    label: {
      fontSize: 16,
      fontWeight: 500,
      lineHeight: "100%",
      textAlign: "center",
    },
  },
};
